import React, { useContext } from "react";
import PaymentContext from "../../../store/PaymentContext";
import { useRouter } from "next/router";

interface IProps {
    active: boolean,
    color: string,
    currentStep: number
}

const Step3: React.FC<IProps> = ({ active, color, currentStep }) => {
    const { isMobile } = useContext(PaymentContext)
    const router = useRouter();
    let colorActive = '#274FF5';
    let colorUnActive = '#595959'
    return (
        <>
            {
                currentStep >= 3 && (
                    <div className="text-lg cart_header-text-action" style={{ color: `${active ? colorActive : colorUnActive}` }}>
                        Hoàn thành đơn hàng
                    </div>
                )
            }
            <div
            // onClick={() => {
            //     if (currentStep === 3) {
            //         router.push('/order-success')
            //     }

            // }}
            >
                <svg width={isMobile ? 24 : 32} height={isMobile ? 24 : 32} viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_i_3960_174675)">
                        <circle cx={22} cy={22} r={22} fill={active ? colorActive : 'white'} />
                    </g>
                    <path d="M29.856 14.1489C29.4394 13.7231 28.8227 13.5656 28.2477 13.7322L14.8394 17.6064C14.2327 17.7747 13.8027 18.2556 13.6869 18.8656C13.5685 19.4872 13.9819 20.2772 14.5219 20.6072L18.7144 23.1672C19.1444 23.4306 19.6994 23.3647 20.0552 23.0081L24.856 18.2072C25.0977 17.9564 25.4977 17.9564 25.7394 18.2072C25.981 18.4481 25.981 18.8406 25.7394 19.0906L20.9302 23.8914C20.5735 24.2481 20.5069 24.8014 20.7694 25.2322L23.331 29.4406C23.631 29.9397 24.1477 30.2239 24.7144 30.2239C24.781 30.2239 24.856 30.2239 24.9227 30.2147C25.5727 30.1322 26.0894 29.6897 26.281 29.0647L30.256 15.7572C30.431 15.1906 30.2727 14.5739 29.856 14.1489Z" fill={active ? 'white' : colorUnActive} />
                    <path opacity="0.4" fillRule="evenodd" clipRule="evenodd" d="M14.5086 26.0066C14.3486 26.0066 14.1886 25.9458 14.0669 25.8233C13.8227 25.5791 13.8227 25.1841 14.0669 24.94L15.2044 23.8016C15.4486 23.5583 15.8444 23.5583 16.0886 23.8016C16.3319 24.0458 16.3319 24.4416 16.0886 24.6858L14.9502 25.8233C14.8286 25.9458 14.6686 26.0066 14.5086 26.0066ZM17.6429 27.0003C17.4829 27.0003 17.3229 26.9395 17.2012 26.817C16.9571 26.5728 16.9571 26.1778 17.2012 25.9336L18.3387 24.7953C18.5829 24.552 18.9787 24.552 19.2229 24.7953C19.4662 25.0395 19.4662 25.4353 19.2229 25.6795L18.0846 26.817C17.9629 26.9395 17.8029 27.0003 17.6429 27.0003ZM17.8543 29.9736C17.976 30.0961 18.136 30.157 18.296 30.157C18.456 30.157 18.616 30.0961 18.7377 29.9736L19.876 28.8361C20.1193 28.592 20.1193 28.1961 19.876 27.952C19.6318 27.7086 19.236 27.7086 18.9918 27.952L17.8543 29.0903C17.6102 29.3345 17.6102 29.7295 17.8543 29.9736Z" fill={active ? 'white' : colorUnActive} />
                    <defs>
                        <filter id="filter0_i_3960_174675" x={0} y={0} width={44} height={48} filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                            <feFlood floodOpacity={0} result="BackgroundImageFix" />
                            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                            <feOffset dy={4} />
                            <feGaussianBlur stdDeviation={2} />
                            <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                            <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3960_174675" />
                        </filter>
                    </defs>
                </svg>

            </div>
        </>
    )
}

export default Step3
